@if (hasData()) {
<div
  style="height: 100%"
  echarts
  [options]="chartOption"
  (chartInit)="onChartInit($event)"
></div>
} @else {
<div class="w-full h-full flex justify-center items-center">
  <p>Nada que mostrar</p>
</div>
}
